import * as React from "react";
import { MessageProvider } from "@messageformat/react";
import LandingPro from "../landing/LandingPro";
import { siteMessages } from "../translations";

const IndexPage = () => (
  <MessageProvider messages={siteMessages.fi}>
    <LandingPro />
  </MessageProvider>
);

export default IndexPage;
